import { useState } from "react";

/**
 * 附件/文件上传状态 Hook
 */
const useAttachmentState = () => {
  const [attachedFiles, setAttachedFiles] = useState([]); // 存储待上传的文件对象数组
  const [isFileUploading, setIsFileUploading] = useState(false); // 控制文件上传过程的加载状态
  const [conflictDialog, setConflictDialog] = useState({
    isOpen: false,
    fileId: null,
    fileName: null,
    serverContent: null,
    localContent: null,
    onResolve: null,
  });

  // 重置附件状态
  const resetAttachmentState = () => {
    setAttachedFiles([]);
    setIsFileUploading(false);
    setConflictDialog({
      isOpen: false,
      fileId: null,
      fileName: null,
      serverContent: null,
      localContent: null,
      onResolve: null,
    });
  };

  return {
    attachedFiles,
    setAttachedFiles,
    isFileUploading,
    setIsFileUploading,
    conflictDialog,
    setConflictDialog,
    resetAttachmentState,
  };
};

export default useAttachmentState;
